'use client'

export default function LandingBlockHowDoesItWork(props: any) {
    return (
        <div style={{maxWidth: 600}} className={"px-4 lg:px-0"}>
            <div className={"text-xl mb-7 md:mb-4 lg:mb-3 font-light"}>
                <span className={"text-4xl font-semibold"}>🤓 How does it work?</span>
                <div className={"border-b border-b-fuchsia-200 w-10 md:w-20 lg:w-96 my-7"}></div>
            </div>
            <div className={"text-xl mb-7 md:mb-4 lg:mb-3 font-light"}>
                <span className={"font-bold"}>Select</span> the strategies and stocks you trade.
                <div className={"text-sm text-gray-500 mt-2"}>
                    The app shows you trades that have highest profit probability and lowest risk,
                    so you can increase your earnings and reduce loss.
                </div>
            </div>
            <div className={"text-xl mb-7 md:mb-4 lg:mb-3 font-light"}>
                Novice trader? Just use our <span className={"font-bold"}>default preferences</span>.
                <div className={"text-sm text-gray-500 mt-2"}>
                    You will get the best options with max profit probability and lowest risk.
                </div>
            </div>
            <div className={"text-xl mb-7 md:mb-4 lg:mb-3 font-light"}>
                Advanced trader? Set your risk and profit preferences
                <div className={"text-sm text-gray-500 mt-2"}>
                    Max margin, min credit, max debit, min credit to profit ratio, spread widths,
                    greeks and more. Per each strategy!
                </div>
            </div>
            <div className={"text-xl mb-7 md:mb-4 lg:mb-3 font-light"}>
                <span className={"font-bold"}>The scanner</span> checks and compares
                each single possible option variation.
            </div>
            <div className={"text-xl mb-7 md:mb-4 lg:mb-3 font-light"}>
                The app compares all expirations, strikes and greeks.
            </div>
            <div className={"text-xl mb-7 md:mb-4 lg:mb-3 font-light"}>
                And you get <span className={"font-bold text-amber-400"}>the best</span> trades in real
                time
                🤌
                <div className={"text-sm text-gray-500 mt-2"}>
                    We are looking for trades with highest profit probability, lowest risks, and
                    best profit to loss ratio. Across all the selected companies, strategies, and
                    expirations.
                </div>
            </div>
        </div>
    )
}
